const MINUS = '−'; // typographic minus, aligns with '+'

export function formatPrice(value: string | number | null | undefined, currency = 'EUR'): string {
  if (value === null || value === undefined || value === '') return '-';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '-';
  const symbol = currency === 'EUR' ? '€' : `${currency} `;
  return `${symbol}${Math.round(n).toLocaleString()}`;
}

export function formatPct(value: number | null | undefined): string {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '-';
  if (value > 0) return `+${value.toFixed(1)}%`;
  if (value < 0) return `${MINUS}${Math.abs(value).toFixed(1)}%`;
  return '±0.0%';
}

// 1 ft = 0.3048 m exactly. Boats are stored in meters (numeric(5,2)) but the
// UI shows feet because charterers think in feet.
const M_PER_FT = 0.3048;

/** Convert a metric-meter length to whole feet via round-to-nearest. */
export function metersToFeet(m: number): number {
  return Math.round(m / M_PER_FT);
}

/**
 * Format a length value (meters, string from numeric column or number) as
 * `"NN ft"` for the UI. Returns `'—'` for null / undefined / unparseable.
 */
export function formatLengthFt(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '—';
  const m = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(m)) return '—';
  return `${metersToFeet(m)} ft`;
}
